const GENERIC_STAFF_LABELS = new Set([
  'staff',
  'staff member',
  'teacher',
  'your teacher',
  'unknown',
  'unknown staff member',
]);

const isSystemActorId = value =>
  typeof value === 'string' && value.trim().startsWith('system-');

const isUsableStaffName = value => {
  if (typeof value !== 'string') return false;
  const clean = value.replace(/\s+/g, ' ').trim().toLowerCase();
  return clean && !GENERIC_STAFF_LABELS.has(clean);
};

export function snapshotStaffIdentity(record = {}) {
  const issuedById = [
    record.issuedById,
    record.issuedBy,
    record.teacherId,
    record.createdBy,
  ].find(value => typeof value === 'string' && value.trim() &&
    !isSystemActorId(value)) || null;
  const issuedByName = [
    record.issuedByName,
    record.teacherName,
    record.createdByName,
  ].find(isUsableStaffName) || null;

  return { issuedById, issuedByName };
}
